var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable react/forbid-prop-types, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var _require = require("aphrodite"),
    StyleSheet = _require.StyleSheet,
    css = _require.css;

var ApiOptions = require("../perseus-api.jsx").Options;
var Changeable = require("../mixins/changeable.jsx");
var Editor = require("../editor.jsx");
var TextInput = require("../components/text-input.jsx");
var InlineIcon = require("../components/inline-icon.jsx");

var _require2 = require("../icon-paths.js"),
    iconPlus = _require2.iconPlus,
    iconTrash = _require2.iconTrash;

var GradedGroupEditor = React.createClass({
    displayName: "GradedGroupEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        title: React.PropTypes.string,
        content: React.PropTypes.string,
        widgets: React.PropTypes.object,
        images: React.PropTypes.object,
        apiOptions: ApiOptions.propTypes
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            title: "",
            content: "",
            widgets: {},
            images: {},
            hint: null
        };
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    handleAddHint: function handleAddHint() {
        var _this = this;

        var hint = { content: "" };
        this.props.onChange({ hint: hint }, function () {
            _this.refs["hint-editor"].focus();
        });
    },

    handleRemoveHint: function handleRemoveHint(i) {
        this.props.onChange({ hint: null });
    },

    render: function render() {
        var _this2 = this;

        return React.createElement(
            "div",
            { className: "perseus-group-editor" },
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(
                    "label",
                    { className: css(styles.title) },
                    "Title:",
                    " ",
                    React.createElement(TextInput, {
                        value: this.props.title,
                        className: css(styles.input),
                        onChange: this.change("title")
                    })
                )
            ),
            React.createElement(Editor, {
                ref: "editor",
                content: this.props.content,
                widgets: this.props.widgets,
                apiOptions: this.props.apiOptions,
                images: this.props.images,
                widgetEnabled: true,
                immutableWidgets: false,
                onChange: this.props.onChange,
                warnNoPrompt: true,
                warnNoWidgets: true
            }),
            !this.props.hint && React.createElement(
                "button",
                {
                    type: "button",
                    style: { marginTop: 10 },
                    className: "add-hint simple-button orange",
                    onClick: this.handleAddHint
                },
                React.createElement(InlineIcon, iconPlus),
                " Add a hint"
            ),
            this.props.hint && React.createElement(
                "div",
                { className: "perseus-hint-editor" },
                React.createElement(
                    "div",
                    { className: css(styles.hintsTitle) },
                    "Hint"
                ),
                React.createElement(Editor, {
                    ref: "hint-editor",
                    content: this.props.hint ? this.props.hint.content : "",
                    widgets: this.props.hint ? this.props.hint.widgets : {},
                    apiOptions: this.props.apiOptions,
                    images: this.props.hint && this.props.hint.images,
                    widgetEnabled: true,
                    immutableWidgets: false,
                    onChange: function onChange(props) {
                        // Copy all props over from the existing hint
                        // and then add new props.
                        _this2.change("hint", Object.assign({}, _this2.props.hint, props));
                    }
                }),
                React.createElement(
                    "button",
                    {
                        type: "button",
                        className: "remove-hint simple-button orange",
                        onClick: this.handleRemoveHint
                    },
                    React.createElement(InlineIcon, iconTrash),
                    " Remove this hint"
                )
            )
        );
    },

    getSaveWarnings: function getSaveWarnings() {
        return this.refs.editor.getSaveWarnings();
    },

    serialize: function serialize() {
        return _extends({
            title: this.props.title
        }, this.refs.editor.serialize(), {
            hint: this.refs["hint-editor"] && this.refs["hint-editor"].serialize()
        });
    }
});

var styles = StyleSheet.create({
    title: {
        fontSize: 18,
        fontWeight: "bold"
    },

    input: {
        fontSize: 18
    },

    hintsTitle: {
        marginTop: 10,
        fontSize: "110%",
        fontWeight: "bold"
    }
});

module.exports = GradedGroupEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/graded-group-editor.jsx
 ** module id = 107
 ** module chunks = 0 1
 **/